import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { NavigationProcessing } from "@logex/framework/lg-application";
import { UiCoreModule } from "@logex/framework/ui-core";
import { LgLocalizationModule } from "@logex/framework/lg-localization";
import { LgChartsModule } from "@logex/framework/lg-charts";

import { AppNavigationProcessing } from "./services/app-navigation-processing.service";

import { AsActivityPipe } from "./pipes/as-activity.pipe";
import { AsAgeCategoryPipe } from "./pipes/as-ageCategory.pipe";
import { AsDiagnosisGroupPipe } from "./pipes/as-diagnosisGroup.pipe";
import { AsDiagnosisPipe } from "./pipes/as-diagnosis.pipe";
import { AsGenderPipe } from "./pipes/as-gender.pipe";
import { AsSpecialismPipe } from "./pipes/as-specialism.pipe";
import { AsInsurerPipe } from "./pipes/as-insurer.pipe";
import { AsAc1Pipe } from "./pipes/as-ac1.pipe";
import { AsAc2Pipe } from "./pipes/as-ac2.pipe";
import { AsAc3Pipe } from "./pipes/as-ac3.pipe";
import { AsTrc1Pipe } from "./pipes/as-trc1.pipe";
import { AsTrc2Pipe } from "./pipes/as-trc2.pipe";
import { AsTrc3Pipe } from "./pipes/as-trc3.pipe";
import { FormatMetricPipe } from "./pipes/format-metric.pipe";
import { LinkifiedPipe } from "./pipes/linkified.pipe";
import { LinkifyDirective } from "./directives/linkify.directive";
import { SafeFormatPipe } from "./pipes/format-safe-type.pipe";
import { FlagsMenuComponent } from "./components/flags-menu/flags-menu.component";
import { FlagsMenuPopupComponent } from "./components/flags-menu/flags-menu-popup.component";
import { LgFiltersetModule } from "@logex/framework/lg-filterset";
import { LgPivotTableModule } from "@logex/framework/lg-pivot-table";
import { ReferenceSelectorComponent } from "./components/reference-selector/reference-selector.component";
import { ReferenceSelectorPopupComponent } from "./components/reference-selector/reference-selector-popup.component";
import { FlagsSelectorComponent } from "./components/flags-selector/flags-selector.component";
import {
    FlagsSelectorDialog,
    FlagsSelectorDialogComponent
} from "./components/flags-selector/flags-selector-dialog.component";

import { OrdinalSuffix } from "./pipes/fmt-ordinal.pipe";
import { DecorateTextDirective } from "./directives/decorateText.directive";
import { InfoRecordComponent } from "./components/info-record/info-record.component";
import { SavingFlagsService } from "./services/saving-flags.service";
import { SidebarButtonDashboardComponent } from "./components/sidebar-button-dashboard.component";
import { HELP_LINKS, standardlinks } from "./types";
import { TooltipObservedDirective } from "./directives/tooltip-observed.directive";
import { LocalCommentIconComponent } from "./components/local-comment/local-comment-icon/local-comment-icon.component";
import {
    LocalCommentEditDialog,
    LocalCommentEditDialogComponent
} from "./components/local-comment/local-comment-dialog/mod-local-comment-dialog.component";
import {
    SaveInitiativeDialog,
    SaveInitiativeDialogComponent
} from "./initiatives-creator/save-initiative-dialog.component";
import { ReactiveFormsModule } from "@angular/forms";

@NgModule({
    imports: [
        CommonModule,
        ReactiveFormsModule,
        UiCoreModule,
        LgLocalizationModule,
        LgChartsModule,
        LgPivotTableModule,
        LgFiltersetModule
    ],
    exports: [
        AsActivityPipe,
        AsAgeCategoryPipe,
        AsDiagnosisGroupPipe,
        AsDiagnosisPipe,
        AsGenderPipe,
        AsInsurerPipe,
        AsSpecialismPipe,
        AsAc1Pipe,
        AsAc2Pipe,
        AsAc3Pipe,
        AsTrc1Pipe,
        AsTrc2Pipe,
        AsTrc3Pipe,
        OrdinalSuffix,
        LinkifiedPipe,
        FormatMetricPipe,
        SafeFormatPipe,
        LinkifyDirective,
        DecorateTextDirective,
        TooltipObservedDirective,
        FlagsMenuComponent,
        FlagsMenuPopupComponent,
        FlagsSelectorComponent,
        FlagsSelectorDialogComponent,
        LocalCommentIconComponent,
        LocalCommentEditDialogComponent,
        InfoRecordComponent,
        ReferenceSelectorComponent,
        ReferenceSelectorPopupComponent,
        SaveInitiativeDialogComponent,
        SidebarButtonDashboardComponent
    ],
    declarations: [
        AsActivityPipe,
        AsAgeCategoryPipe,
        AsDiagnosisGroupPipe,
        AsDiagnosisPipe,
        AsGenderPipe,
        AsInsurerPipe,
        AsSpecialismPipe,
        AsAc1Pipe,
        AsAc2Pipe,
        AsAc3Pipe,
        AsTrc1Pipe,
        AsTrc2Pipe,
        AsTrc3Pipe,
        LinkifiedPipe,
        FormatMetricPipe,
        OrdinalSuffix,
        SafeFormatPipe,
        LinkifyDirective,
        DecorateTextDirective,
        TooltipObservedDirective,
        FlagsMenuComponent,
        FlagsMenuPopupComponent,
        FlagsSelectorComponent,
        FlagsSelectorDialogComponent,
        LocalCommentIconComponent,
        LocalCommentEditDialogComponent,
        InfoRecordComponent,
        ReferenceSelectorComponent,
        ReferenceSelectorPopupComponent,
        SaveInitiativeDialogComponent,
        SidebarButtonDashboardComponent
    ],
    providers: [
        SavingFlagsService,
        SaveInitiativeDialog,
        FlagsSelectorDialog,
        LocalCommentEditDialog,
        {
            provide: NavigationProcessing,
            useClass: AppNavigationProcessing
        },
        {
            provide: HELP_LINKS,
            useValue: standardlinks
        }
    ]
})
export class SharedModule {
    // empty
}
